import { Flex, SlideFade } from '@chakra-ui/react'
import React from 'react'
import { Redirect } from 'react-router-dom'
import ExtensionLandingPage from 'src/pages/ExtensionLandingPage'
import { useIamStore } from '../../apis/store'
import ConfirmEmailVerification from '../ConfirmEmailVerification'
import CtaRegister from '../CtaRegister'
import LogInEmailVerification from '../LogInEmailVerification'
import LoginForm from '../LoginForm'
import RegisterNewPassword from '../RegisterNewPassword'
import UserRegisterForm from '../UserRegisterForm'

const LogInContainer: React.FC = () => {
  const { state } = useIamStore((store) => ({ state: store.state }))

  const conditionToNotPinContainer = state('REGISTER_NEW_PASSWORD') || state('REGISTER.REGISTER_FORM')

  if (state('LOGGED_IN')) {
    return <Redirect to={{ pathname: '/home' }} />
  }

  return (
    <Flex
      flexDir='column'
      width='100%'
      alignItems='center'
      justifyContent='center'
      padding='32px'
      bg='white'
      position={{ base: conditionToNotPinContainer ? 'unset' : 'fixed', lg: 'unset' }}
      bottom={{ base: conditionToNotPinContainer ? 'unset' : 0, lg: 'unset' }}
      borderTopRadius={{ base: 30, lg: 0 }}
    >
      {state('VERIFY_EMAIL') ? (
        <SlideFade in={state('VERIFY_EMAIL')} offsetY='40px'>
          <LogInEmailVerification />
        </SlideFade>
      ) : undefined}
      {state('CONFIRM_EMAIL_VERIFICATION') ? (
        <SlideFade in={state('CONFIRM_EMAIL_VERIFICATION')} offsetY='40px'>
          <ConfirmEmailVerification />
        </SlideFade>
      ) : undefined}
      {state('USER_CREDENTIALS') ? (
        <SlideFade in={state('USER_CREDENTIALS')} offsetY='40px'>
          <LoginForm />
        </SlideFade>
      ) : undefined}
      {state('REGISTER.CTA_REGISTER') ? (
        <SlideFade in={state('REGISTER.CTA_REGISTER')} offsetY='40px'>
          <CtaRegister />
        </SlideFade>
      ) : undefined}
      {state('REGISTER.REGISTER_FORM') ? (
        <SlideFade in={state('REGISTER.REGISTER_FORM')} offsetY='40px'>
          <UserRegisterForm />{' '}
        </SlideFade>
      ) : undefined}
      {state('REGISTER.VERIFY_EMAIL') ? (
        <SlideFade in={state('REGISTER.VERIFY_EMAIL')} offsetY='40px'>
          <ConfirmEmailVerification />{' '}
        </SlideFade>
      ) : undefined}
      {state('REGISTER.CTA_EXTENSION') ? <ExtensionLandingPage /> : undefined}
      {state('REGISTER_NEW_PASSWORD') ? (
        <SlideFade in={state('REGISTER_NEW_PASSWORD')} offsetY='40px'>
          <RegisterNewPassword />{' '}
        </SlideFade>
      ) : undefined}
    </Flex>
  )
}

export default LogInContainer
